<div class="dropdown open"  [appOffClick]="closeDropDown">

  <span #spanField class="select {{inputCssClass}}" tabindex="-1">
    <span class="suggest-select-placeholder {{inputCssClass==='form-control form-control-sm'?'pt-1':'pt-2'}} "
      [ngClass]="{'text-muted':isDisable}">
      {{selectedItems.length?selectedItems.length===1?selectedItems[0].name:selectedItems.length+' items selected'
      :placeholder}}</span>

    <i style="top: 4px; right: 10px; font-size: 16px;" class="dropdown-toggle pull-right {{inputCssClass==='form-control form-control-sm'?'pt-0':'pt-1'}}"></i>
  </span>
  

  <!-- <div class="form-check" >
    <input class="form-check-input" type="checkbox" [checked]="selectedItems?.length === mappedOptions?.length">
    <label class="form-check-label" style="display: -webkit-box" (click)="onClickMultiple()"></label>
    <input #inputField autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="inputValue"
      type="text" (input)="inputChanges($event.target.value)" id="name" class="form-control form-control-sm">
  </div> -->


  <div class="dropdown-container">
    <div class="input-group p-1" *ngIf="(!isGroup&&!!options?.length&&dropDown) || (isGroup&&!!optionsGroup?.length&&dropDown)">
      <div class="input-group-prepend ps-0 d-flex">
        <div class="input-group-text" style="border: 0; background-color: antiquewhite;">
          <div class="form-check mb-0 ms-2" *ngIf="(!isGroup&&!!options?.length&&dropDown) || (isGroup&&!!optionsGroup?.length&&dropDown)">
            <input class="form-check-input" type="checkbox" [checked]="isChecked"  (click)="onClickMultiple()" (click)="$event.stopPropagation()">
            <label class="form-check-label" style="display: -webkit-box" ></label>
          </div>
        </div>
      </div>
      <input #inputField autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" [(ngModel)]="inputValue"
        type="other" (minput)="inputChanges($event)"  appFocusNext="multi" (input)="inputChanges($event.target.value)" id="name" class="form-control form-control-sm me-2 ps-2">
    </div>
    <ul *ngIf="!isGroup&&!!options?.length&&dropDown" class="dropdown-menu p-0 b-0" role="menu">
      <li *ngFor="let o of options | search:inputValue:'name':'startsWith'" role="menuitem" style="border-top: 1px solid antiquewhite;">
        <div class="drop-down-row" [ngClass]="{'active':o?.checked}" (mouseenter)="mouseOver(o)" (mouseleave)="mouseleave()">
          <a #dropDownItem style="line-height: 1.7; padding: 3px 10px; margin: 4px 3px 0px;" href="javascript:void(0)" (click)="itemSelected(o,true)" tabindex="-1" class="dropdown-item" (click)="$event.stopPropagation()">
            <app-checkbox labelName="{{((o?.prefix)?o?.prefix+' ':'')+o?.name+(o?.suffix?' '+o?.suffix:'')}}" [value]="o?.checked"></app-checkbox>
          </a>
        </div>
      </li>
    </ul>
    <ul *ngIf="isGroup&&!!optionsGroup?.length&&dropDown" class="dropdown-menu" role="menu">
      <li *ngFor="let o of optionsGroup" role="menuitem">
        <div class="dropdown-toolbar">{{o?.title}}</div>
        <ng-container *ngFor="let sub of o.options | search:inputValue">
          <div class="drop-down-row" [ngClass]="{'active':sub?.checked}" (mouseenter)="mouseOver(sub)" (mouseleave)="mouseleave()">
            <a #dropDownItem href="javascript:void(0)" (click)="itemSelected(sub,true)" tabindex="-1" class="dropdown-item" (click)="$event.stopPropagation()">
              <app-checkbox labelName="{{((sub?.prefix)?sub?.prefix+' ':'')+sub?.name+(sub?.suffix?' '+sub?.suffix:'')}}" [value]="sub?.checked"></app-checkbox>
              <!-- <div>{{sub?.name}}</div> -->
            </a>
          </div>
        </ng-container>
      </li>
    </ul>
    <ng-container *ngIf="dropDown&&!!addMoreTemplate">
      <ng-container *ngTemplateOutlet="addMoreTemplate"></ng-container>
    </ng-container>
  </div>
</div>